import { 
    DIALOG_BTN1,
    DIALOG_BTN2,
    DIALOG_CLOSE,
    DIALOG_OPEN,
    DIALOG_WAIT
} from "../../constants/action-types";

export function dialogBtn1(){
    return { type: DIALOG_BTN1 } }

export function dialogBtn2(){
    return { type: DIALOG_BTN2 } }

export function dialogClose(){
    return { type: DIALOG_CLOSE } }

export function dialogOpen(data){
    return { type: DIALOG_OPEN, payload: data } }

export function dialogWait(){
    return { type: DIALOG_WAIT } }



// WEBPACK FOOTER //
// ./src/store/actions/msgDialog.js